import api, { responseErrorCheck } from './api'

export default class CustomConfiguration {
  static endpoint = '/companyCode'

  static getCompanyConfigurationCode(): Promise<String[]> {
    return api.get<any>(this.endpoint).then(responseErrorCheck)
  }
}
